import React from "react"
import styles from "./styles.scss"
import cx from "classnames"
import Position from "./Position"
import { Query } from "react-apollo"
import gql from "graphql-tag"
import { detect } from "detect-browser"

const browser = detect()

const GET_POSITIONS = gql`
  {
    availablePositions @client {
      title
      path
      description
    }
  }
`

const AvailablePositions = ({ variant }) => (
  <section
    className={cx(styles.container, {
      [styles.light]: variant === "light",
      [styles.gray]: variant === "gray",
    })}
  >
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Lediga tjänster</h2>
      <div
        className={cx(styles.positionContainer, {
          [styles.ie]: browser.name === "ie",
        })}
      >
        <Query query={GET_POSITIONS}>
          {({ data }) =>
            data.availablePositions.map(position => (
              <Position
                key={position.title}
                path={position.path}
                icon={["far", "code"]}
                title={position.title}
                variant={variant}
                description={position.description}
              />
            ))
          }
        </Query>
      </div>
    </div>
  </section>
)

AvailablePositions.defaultProps = {
  variant: "dark",
}

export default AvailablePositions



// WEBPACK FOOTER //
// ./src/components/AvailablePositions/index.jsx